(() => {
  class CelsoCourseShelf extends HTMLElement {
    constructor() {
      super();

      this.filterButtons = [];
      this.sliders = [];
      this.filtersContainer = null;
      this.searchTrigger = null;
      this.viewAllModalTriggers = [];
      this.sliderRetryId = null;
      this.sliderRetryCount = 0;
      this.maxSliderRetryAttempts = 30;
      this.sliderRetryDelay = 100;
      this.pendingPanelId = null;
      this.initialized = false;

      this.handleSearchClick = this.openSearch.bind(this);
      this.handleSearchKeydown = this.onSearchKeydown.bind(this);
      this.handleViewAllModalClick = this.openCourseFinder.bind(this);
      this.handleFilterClick = this.onFilterClick.bind(this);
      this.handleFilterKeydown = this.onFilterKeydown.bind(this);
      this.handleSlickRefresh = this.onSlickRefresh.bind(this);
    }

    connectedCallback() {
      if (this.initialized) return;

      this.initialized = true;
      this.cacheElements();
      this.bindEvents();
      this.initialize();
    }

    disconnectedCallback() {
      this.unbindEvents();
      this.clearSliderRetry();
      this.initialized = false;
    }

    cacheElements() {
      this.filterButtons = Array.from(this.querySelectorAll('.filter-btn'));
      this.sliders = Array.from(this.querySelectorAll('.slider-block'));
      this.filtersContainer = this.querySelector('.cursos-filters__tabs');
      this.searchTrigger = this.querySelector('[data-open-find-course-shelf]');
      this.viewAllModalTriggers = Array.from(this.querySelectorAll('[data-course-finder-view-all-trigger]'));
    }

    bindEvents() {
      this.searchTrigger?.addEventListener('click', this.handleSearchClick);
      this.searchTrigger?.addEventListener('keydown', this.handleSearchKeydown);
      this.viewAllModalTriggers.forEach((trigger) => {
        trigger.addEventListener('click', this.handleViewAllModalClick);
      });
      this.filtersContainer?.addEventListener('click', this.handleFilterClick);
      this.filtersContainer?.addEventListener('keydown', this.handleFilterKeydown);
    }

    unbindEvents() {
      this.searchTrigger?.removeEventListener('click', this.handleSearchClick);
      this.searchTrigger?.removeEventListener('keydown', this.handleSearchKeydown);
      this.viewAllModalTriggers.forEach((trigger) => {
        trigger.removeEventListener('click', this.handleViewAllModalClick);
      });
      this.filtersContainer?.removeEventListener('click', this.handleFilterClick);
      this.filtersContainer?.removeEventListener('keydown', this.handleFilterKeydown);

      const jquery = this.getJQuery();
      if (!jquery) return;

      this.sliders.forEach((slider) => {
        const $slider = jquery(slider);
        $slider.off('init.shelfCupom', this.handleSlickRefresh);
        $slider.off('setPosition.shelfCupom afterChange.shelfCupom', this.handleSlickRefresh);
      });
    }

    getJQuery() {
      const jquery = window.jQuery || window.$;

      if (!jquery || typeof jquery.fn?.slick !== 'function') {
        return null;
      }

      return jquery;
    }

    initialize() {
      if (this.filterButtons.length > 0) {
        const firstButton = this.filterButtons[0];
        this.setActiveTab(firstButton, false);
        this.showSlider(firstButton.getAttribute('aria-controls'));
      } else if (this.sliders.length > 0) {
        this.showSlider(this.sliders[0].id);
      }

      this.refreshCourseCards(true);
    }

    refreshCourseCards(resetModalidade) {
      this.querySelectorAll('celso-course-card').forEach((card) => {
        if (resetModalidade && typeof card.setDefaultModalidade === 'function') {
          card.setDefaultModalidade(true);
        }

        if (typeof card.applyState === 'function') {
          card.applyState();
        }
      });
    }

    openSearch() {
      const heroCard = document.querySelector('.mid-banner .find-course-card');
      const card = heroCard || document.getElementById('find-course-card-header');
      if (!card) return;

      if (heroCard && heroCard.parentElement !== document.body) {
        heroCard._originalParent = heroCard.parentElement;
        heroCard._originalNextSibling = heroCard.nextSibling;
        document.body.appendChild(heroCard);
      }

      if (heroCard) heroCard.classList.add('find-course-card--from-search');

      card.classList.add('is-visible');
      card.setAttribute('aria-hidden', 'false');
      this.searchTrigger?.setAttribute('aria-expanded', 'true');
    }

    onSearchKeydown(event) {
      if (event.key !== 'Enter' && event.key !== ' ' && event.key !== 'Spacebar') return;

      event.preventDefault();
      this.openSearch();
    }

    openCourseFinder(event) {
      if (typeof window.abrirCourseFinder !== 'function') return;

      event.preventDefault();
      window.abrirCourseFinder({ ignorePoloContext: true });
    }

    showSlider(panelId) {
      this.sliders.forEach((slider) => {
        const matchesPanel = slider.id === panelId;
        slider.style.display = matchesPanel ? 'block' : 'none';
        slider.toggleAttribute('hidden', !matchesPanel);
        slider.setAttribute('aria-hidden', matchesPanel ? 'false' : 'true');
        slider.setAttribute('tabindex', matchesPanel ? '0' : '-1');

        if (matchesPanel) {
          this.initializeSlider(slider, panelId);
        }
      });
    }

    initializeSlider(slider, panelId) {
      if (slider.querySelectorAll('.course-card').length === 0) return;

      const jquery = this.getJQuery();
      if (!jquery) {
        this.scheduleSliderInitialization(panelId);
        return;
      }

      this.clearSliderRetry();

      const $slider = jquery(slider);
      this.bindSliderEvents($slider);

      if (!slider.classList.contains('slick-initialized')) {
        $slider.slick({
          slide: '.course-card',
          infinite: false,
          dots: true,
          slidesToShow: 4,
          slidesToScroll: 4,
          responsive: [
            {
              breakpoint: 1024,
              settings: { slidesToShow: 3, slidesToScroll: 3 },
            },
            {
              breakpoint: 866,
              settings: { slidesToShow: 2, slidesToScroll: 2 },
            },
            {
              breakpoint: 600,
              settings: { slidesToShow: 1, slidesToScroll: 1, variableWidth: true },
            },
          ],
        });
        return;
      }

      $slider.slick('setPosition');
      this.refreshCourseCards(false);
    }

    bindSliderEvents($slider) {
      $slider.off('init.shelfCupom', this.handleSlickRefresh);
      $slider.off('setPosition.shelfCupom afterChange.shelfCupom', this.handleSlickRefresh);
      $slider.on('init.shelfCupom', this.handleSlickRefresh);
      $slider.on('setPosition.shelfCupom afterChange.shelfCupom', this.handleSlickRefresh);
    }

    onSlickRefresh() {
      this.refreshCourseCards(false);
    }

    scheduleSliderInitialization(panelId) {
      this.pendingPanelId = panelId;
      if (this.sliderRetryId !== null) return;
      if (this.sliderRetryCount >= this.maxSliderRetryAttempts) {
        this.pendingPanelId = null;
        return;
      }

      this.sliderRetryCount += 1;

      this.sliderRetryId = window.setTimeout(() => {
        this.sliderRetryId = null;
        const pendingPanelId = this.pendingPanelId;
        this.pendingPanelId = null;

        if (this.isConnected && pendingPanelId) {
          this.showSlider(pendingPanelId);
        }
      }, this.sliderRetryDelay);
    }

    clearSliderRetry() {
      if (this.sliderRetryId !== null) {
        window.clearTimeout(this.sliderRetryId);
        this.sliderRetryId = null;
      }
      this.pendingPanelId = null;
      this.sliderRetryCount = 0;
    }

    setActiveTab(button, shouldFocus) {
      this.filterButtons.forEach((filterButton) => {
        filterButton.classList.remove('active');
        filterButton.setAttribute('aria-selected', 'false');
        filterButton.setAttribute('tabindex', '-1');
      });

      button.classList.add('active');
      button.setAttribute('aria-selected', 'true');
      button.setAttribute('tabindex', '0');

      if (shouldFocus) button.focus();
    }

    activateFilter(button, shouldFocus) {
      this.setActiveTab(button, shouldFocus);
      this.showSlider(button.getAttribute('aria-controls'));
      this.refreshCourseCards(true);
    }

    onFilterClick(event) {
      const button = event.target.closest('.filter-btn');
      if (!button || !this.filtersContainer?.contains(button)) return;

      this.activateFilter(button, true);
    }

    onFilterKeydown(event) {
      const currentButton = event.target.closest('.filter-btn');
      if (!currentButton || !this.filtersContainer?.contains(currentButton)) return;

      const currentIndex = this.filterButtons.indexOf(currentButton);
      if (currentIndex < 0) return;

      let nextButton = null;

      if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
        nextButton = this.filterButtons[currentIndex + 1] || this.filterButtons[0];
      } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
        nextButton = this.filterButtons[currentIndex - 1] || this.filterButtons[this.filterButtons.length - 1];
      } else if (event.key === 'Home') {
        nextButton = this.filterButtons[0];
      } else if (event.key === 'End') {
        nextButton = this.filterButtons[this.filterButtons.length - 1];
      }

      if (!nextButton) return;

      event.preventDefault();
      this.activateFilter(nextButton, true);
    }
  }

  if (!customElements.get('celso-course-shelf')) {
    customElements.define('celso-course-shelf', CelsoCourseShelf);
  }
})();
